import React, { useState } from "react";
import Marquee from "react-marquee-slider";
import Image from "next/image";

interface FAQ {
  id: number;
  question: string;
  answer: string;
}

interface FAQCardProps {
  faq: FAQ;
}

const FAQ: React.FC = () => {
  const staticData: FAQ[] = [
    {
      id: 1,
      question: "Is the venue wheelchair accessible?",
      answer:
        "Yes, our venue is accessible by wheelchair. If you or one of the other guests need one, you can request at the lobby.",
    },
    {
      id: 2,
      question: "Is there going to be a reception?",
      answer: "Yes, but it will be strictly by invitation.",
    },
    {
      id: 3,
      question: "Can I bring a gift?",
      answer: "Absolutely!",
    },
  ];

  const FAQCard: React.FC<FAQCardProps> = ({ faq }) => (
    <div className="p-4 flex flex-col justify-center items-center text-center text-[#FCE2B0] gap-1">
      <h3 className="text-xl font-semibold font-ebGaramond tracking-wider uppercase max-w-[85%] sm:max-w-2xl">
        {faq.question}
      </h3>
      <p className="text-lg font-ebGaramond max-w-[85%] sm:max-w-2xl text-[#FFF3DB] whitespace-pre-line">
        {faq.answer}
      </p>
    </div>
  );

  return (
    <div className="w-full bg-[linear-gradient(180deg,_#00234B_0%,_#002D60_100%)] py-16">
      <div className="text-center mb-6">
        <h1 className="text-5xl font-ntFab text-[#FCE2B0] mb-4">
          Things to Note
        </h1>
      </div>

      <div
        className="flex flex-col gap-4"
        style={{ maxWidth: "100vw", width: "100%" }}
      >
        {staticData.map((faq) => (
          <FAQCard key={faq.id} faq={faq} />
        ))}
      </div>
    </div>
  );
};

export default FAQ;
